/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IntegrationPipedriveSettings', 'model/IntegrationPipedriveSettingsReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/IntegrationPipedriveSettings'), require('../model/IntegrationPipedriveSettingsReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationPipedriveSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.IntegrationPipedriveSettings, root.ForStractionServiceApi.IntegrationPipedriveSettingsReport);
  }
}(this, function(ApiClient, IntegrationPipedriveSettings, IntegrationPipedriveSettingsReport) {
  'use strict';

  /**
   * IntegrationPipedriveSettings service.
   * @module api/IntegrationPipedriveSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new IntegrationPipedriveSettingsApi. 
   * @alias module:api/IntegrationPipedriveSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the integrationPipedriveSettingsAddPut operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/IntegrationPipedriveSettings} body 
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.integrationPipedriveSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling integrationPipedriveSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationPipedriveSettingsCheckPipedriveConnectionGet operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsCheckPipedriveConnectionGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * checkPipedriveConnection
     * @param {String} _4SAPIAppID 
     * @param {String} rootDomain 
     * @param {String} aPIKey 
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsCheckPipedriveConnectionGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.integrationPipedriveSettingsCheckPipedriveConnectionGet = function(_4SAPIAppID, rootDomain, aPIKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsCheckPipedriveConnectionGet";
      }

      // verify the required parameter 'rootDomain' is set
      if (rootDomain == undefined || rootDomain == null) {
        throw "Missing the required parameter 'rootDomain' when calling integrationPipedriveSettingsCheckPipedriveConnectionGet";
      }

      // verify the required parameter 'aPIKey' is set
      if (aPIKey == undefined || aPIKey == null) {
        throw "Missing the required parameter 'aPIKey' when calling integrationPipedriveSettingsCheckPipedriveConnectionGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'rootDomain': rootDomain,
        'APIKey': aPIKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/checkPipedriveConnection', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationPipedriveSettingsClearPipedriveIndicatorsDataPut operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsClearPipedriveIndicatorsDataPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clearPipedriveIndicatorsData
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsClearPipedriveIndicatorsDataPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationPipedriveSettingsClearPipedriveIndicatorsDataPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsClearPipedriveIndicatorsDataPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling integrationPipedriveSettingsClearPipedriveIndicatorsDataPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/clearPipedriveIndicatorsData', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationPipedriveSettingsDeleteGet operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationPipedriveSettingsDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling integrationPipedriveSettingsDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationPipedriveSettingsEditPut operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/IntegrationPipedriveSettings} body 
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationPipedriveSettingsEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling integrationPipedriveSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationPipedriveSettingsLoadAllGet operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/IntegrationPipedriveSettingsReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxPipelineCount  (default to 0)
     * @param {Integer} opts.maxPipelineStagesCount  (default to 0)
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/IntegrationPipedriveSettingsReport>}
     */
    this.integrationPipedriveSettingsLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxPipelineCount': opts['maxPipelineCount'],
        'maxPipelineStagesCount': opts['maxPipelineStagesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [IntegrationPipedriveSettingsReport];

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationPipedriveSettingsSyncPipedrivePipelinesGet operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsSyncPipedrivePipelinesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IntegrationPipedriveSettingsReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * syncPipedrivePipelines
     * @param {String} _4SAPIAppID 
     * @param {Integer} settingsID 
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsSyncPipedrivePipelinesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IntegrationPipedriveSettingsReport}
     */
    this.integrationPipedriveSettingsSyncPipedrivePipelinesGet = function(_4SAPIAppID, settingsID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsSyncPipedrivePipelinesGet";
      }

      // verify the required parameter 'settingsID' is set
      if (settingsID == undefined || settingsID == null) {
        throw "Missing the required parameter 'settingsID' when calling integrationPipedriveSettingsSyncPipedrivePipelinesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'settingsID': settingsID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = IntegrationPipedriveSettingsReport;

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/syncPipedrivePipelines', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationPipedriveSettingsUpdatePipedriveDataGet operation.
     * @callback module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsUpdatePipedriveDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * updatePipedriveData
     * @param {String} _4SAPIAppID 
     * @param {module:api/IntegrationPipedriveSettingsApi~integrationPipedriveSettingsUpdatePipedriveDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationPipedriveSettingsUpdatePipedriveDataGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationPipedriveSettingsUpdatePipedriveDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationPipedriveSettings/updatePipedriveData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
